export const BRANDING_TYPE__ZEDOC = 'ZEDOC';
export const BRANDING_TYPE__ZESIGHT = 'ZeSight';
export const BRANDING_TYPE__CLINICIAN = 'Clinician';
